module.exports = __webpack_public_path__ + "48986330d0cf4f395c22c15eb3a85d.svg";